export default __webpack_public_path__ + "static/media/preipo.b579e865.svg";